module.exports = __webpack_public_path__ + "static/media/allergies.f722f570.svg";